// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAgo9Ax_OOuiZEFfMkYr4SjQ6BJLte4zeE",
  authDomain: "personal-apps-67d82.firebaseapp.com",
  projectId: "personal-apps-67d82",
  storageBucket: "personal-apps-67d82.appspot.com",
  messagingSenderId: "662200873369",
  appId: "1:662200873369:web:26c5352ab673076c6b2308",
  measurementId: "G-07FQ3ECQMR"
};

// Initialize Firebase only in production
let app = null;
let analytics = null;
let remoteConfig = null;

// Check if window exists to avoid SSR issues
const isProduction = process.env.NODE_ENV === "production";
const isBrowser = typeof window !== "undefined";

if (isBrowser) {
  app = initializeApp(firebaseConfig);
  
  if (isProduction) {
    analytics = getAnalytics(app);
  }
  
  // Set up Remote Config
  remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour
  remoteConfig.defaultConfig = {
    profilephoto: "https://i.pravatar.cc/300" // Default fallback avatar
  };
}

// Function to get the profile photo URL from Remote Config
export const getProfilePhoto = async () => {
  if (!remoteConfig) return "https://i.pravatar.cc/300";
  
  try {
    // Fetch and activate the latest config
    await fetchAndActivate(remoteConfig);
    
    // Get the value for profilephoto
    const profilePhotoValue = getValue(remoteConfig, "profilephoto");
    return profilePhotoValue.asString();
  } catch (error) {
    console.error("Error fetching remote config:", error);
    return "https://i.pravatar.cc/300";
  }
};

export { app, analytics, remoteConfig }; 